import { IconButton, styled } from '@mui/material';
import Popper from '@shared/ui/Popper';
import { memo, useRef, useState } from 'react';
import { Menu, MenuItem } from '@/component/Menu';
import { ChatMessage } from '@/feature/chatbot/types';
import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useTexts } from '@/feature/lang';
import { Icon } from '@/icon/Icon';
import { RatingPopper } from './rating/RatingPopper';

const Container = styled('div', {
  name: 'Chatbot',
  slot: 'MessageMenuContainer',
})({ position: 'relative' });

const MenuButton = styled(IconButton, {
  name: 'Chatbot',
  slot: 'MessageMenuButton',
})({
  position: 'absolute',
  top: '-16px',
  left: '-16px',
});

export const MessageMenu = memo(function MessageMenu({
  message,
}: {
  message: ChatMessage;
}) {
  const texts = useTexts().component.chatbot;
  const { conversation } = useChatbot();
  const [ratingOpen, setRatingOpen] = useState(false);
  const viewMenu = Boolean(conversation?.id && message.sender === 'assistant');
  const anchorRef = useRef<HTMLButtonElement>(null);

  if (!viewMenu) {
    return null;
  }

  return (
    <Container>
      <Popper
        Content={({ onClose }) => (
          <Menu onClose={onClose}>
            <MenuItem
              label={texts.rating.menuItem}
              onClick={() => setRatingOpen(true)}
            />
            <MenuItem
              label={texts.actions.copyResponseId}
              onClick={() => {
                navigator.clipboard.writeText(message.id);
              }}
            />
          </Menu>
        )}
        Trigger={({ onClick }) => (
          <MenuButton
            ref={anchorRef}
            onClick={(e) => {
              e.stopPropagation();
              onClick(e);
            }}
            size="small"
          >
            <Icon name="more_vert" size="xsmall" />
          </MenuButton>
        )}
        placement="bottom-end"
      />
      <RatingPopper
        message={message}
        anchorRef={anchorRef}
        isOpen={ratingOpen}
        close={() => setRatingOpen(false)}
      />
    </Container>
  );
});
